// The "Para sempre" book — ports app/(privado)/para-sempre/page.tsx.
//
// The anniversary letter is page 1 (its text is fixed in shared/content.ts);
// the collection messages follow. The featured photo is only needed on the day.

import { Link } from "react-router";
import { anniversary, couple } from "@historia/shared/content";
import { anniversaryOrdinal, anniversaryState } from "@historia/shared/dates";
import { Flourish } from "@/components/ui/Flourish";
import { LivroParaSempre, type CartaAniversario } from "@/components/para-sempre/LivroParaSempre";
import { Consulta } from "@/components/ui/EstadoConsulta";
import { useTitle } from "@/components/ui/useTitle";
import { useFeaturedPhoto, useMessages, usePhotoSummary } from "@/api/queries";

export function ParaSempre() {
  useTitle("Para sempre");

  // Computed in the browser, as before — it only reads the fixed official date.
  const estado = anniversaryState(couple.officialDate);

  const query = useMessages();
  const fotos = usePhotoSummary();
  const destaque = useFeaturedPhoto();

  const carta: CartaAniversario = {
    chegou: estado.arrived,
    diasEmFalta: estado.daysRemaining,
    ordinal: anniversaryOrdinal(estado.yearsToShow),
    fotoSrc: estado.arrived ? destaque.data?.src ?? null : null,
    fotoLegenda: estado.arrived ? destaque.data?.legenda ?? null : null,
    kicker: anniversary.kicker,
    saudacao: anniversary.saudacao,
    paragrafos: anniversary.carta,
    assinatura: anniversary.assinatura,
    rodape: anniversary.rodape,
    teaserKicker: anniversary.teaserKicker,
    teaserTitulo: anniversary.teaserTitulo,
    teaserTexto: anniversary.teaserTexto,
  };

  return (
    <main className="mx-auto max-w-4xl px-6 py-12 sm:py-16">
      <header className="text-center">
        <p className="font-display text-lg italic text-ouro-600">O nosso livro</p>
        <h1 className="mt-1 font-display text-3xl text-tinta sm:text-4xl">Para sempre</h1>
        <div className="my-6">
          <Flourish />
        </div>
          <Link
            to="/para-sempre/adicionar"
            className="inline-block rounded-full bg-ouro px-6 py-3 text-sm font-semibold text-creme-50 shadow-[0_10px_28px_-10px_rgba(201,162,39,0.65)] transition-all hover:bg-ouro-600 hover:-translate-y-0.5"
          >
            + Nova mensagem
          </Link>
      </header>

      <div className="mt-10">
        <Consulta query={query}>
          {(mensagens) => (
            <LivroParaSempre carta={carta} mensagens={mensagens} fotos={fotos.data ?? []} />
          )}
        </Consulta>
      </div>

      <div className="mt-12 text-center">
        <Link
          to="/"
          className="text-sm text-ouro-600 underline-offset-4 transition-colors hover:text-ouro hover:underline"
        >
          ← Voltar ao início
        </Link>
      </div>
    </main>
  );
}
